import { FC } from 'react';
import Link from 'next/link';
import styles from './Next.module.scss';

interface INext {
  currentPageNo?: number;
  pagesCount?: number;
  postName?: string;
}

const Next: FC<INext> = ({ currentPageNo, pagesCount, postName }) => {
  if (!currentPageNo || !pagesCount) {
    return null;
  }

  if (pagesCount < currentPageNo + 1) {
    return null;
  }

  const paginationLink = `/${postName}${currentPageNo + 1}`;

  return (
    <Link prefetch={false} className={styles.next} href={paginationLink}>
      <span className={styles.next__txt}>Следующая</span>
    </Link>
  );
};

export default Next;
